import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { LayoutColors } from '@src/core/theme';
import { baseButton } from '@src/components/Account/shared';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode | string;
  style?: object;
};

const StepNavigationButton = (props: Props) => {
  const { onClick, disabled, children, style } = props;

  return (
    <Button style={style} onClick={onClick} disabled={disabled}>
      {children}
    </Button>
  );
};

export default StepNavigationButton;

const Button = styled.button`
  ${baseButton};
  transition: all 0.2s linear;
  color: ${LayoutColors.whiteLight};
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  text-transform: uppercase;
  background: transparent;

  &:disabled {
    background: ${LayoutColors.grayMain} !important;
    border: 1px solid transparent;
    cursor: not-allowed;
  }
`;
